import React from 'react';
import Footer from '../Footer';
import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import Header from '../Header';

const MainContainer = styled('main')({
  minHeight: '100vh',
  paddingBottom: '2rem'
});

const Layout = ({ children }) => {
  return (
    <>
      <Header />

      <MainContainer>
        {children}

      </MainContainer>
      <Footer />
    </>
  );
};

export default Layout; 